const PROGRESS_BAR_EVENT = Object.freeze({
  PROGRESS: 'progress',
})

const DIRECT_UPLOAD_URL = '/rails/active_storage/direct_uploads'

export { DIRECT_UPLOAD_URL, PROGRESS_BAR_EVENT }
